// extracted by mini-css-extract-plugin
export default {"list":"LanguageChange_list__Ki+b1","label":"LanguageChange_label__lZngJ","checkIcon":"LanguageChange_checkIcon__KzYML"};